var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:['artwork-list', { 'artwork-list--archive': _vm.isArchive }]},_vm._l((_vm.artworks),function(artwork){return _c('artwork-list-item',{key:artwork.id,attrs:{"item":artwork}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }